/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { FaceScanStrictHttpResponse } from '../../face-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SdkConfigModel } from '../../models/sdk-config-model';
import { SdkScanConfigRequestModel } from '../../models/sdk-scan-config-request-model';

export interface SessionSdkScanConfigAsyncPost$Params {
      body?: SdkScanConfigRequestModel
}

export function sessionSdkScanConfigAsyncPost(http: HttpClient, rootUrl: string, params?: SessionSdkScanConfigAsyncPost$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<SdkConfigModel>> {
  const rb = new RequestBuilder(rootUrl, sessionSdkScanConfigAsyncPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as FaceScanStrictHttpResponse<SdkConfigModel>;
    })
  );
}

sessionSdkScanConfigAsyncPost.PATH = '/Session/SDKScanConfigAsync';
